export default "__VITE_ASSET__CRaE4oK7__"